import BackgroundVideo from '../components/BackgroundVideo';

export default class ModCampaign {
  constructor(el) {
    this.$el = $(el);

    this.dom = {
      $bottomOverlayMobile: this.$el.find('.bottom-overlay-mobile'),
      $wrapContentCampaign: this.$el.find('.wrap-content-campaign'),
      $contentDisclaimer: this.$el.find('.content-disclaimer'),
      $overlayTextCampaign: this.$el.find('.overlay-text-campaign'),
      $videos: this.$el.find('.js-iframe-video'),
    };

    this.init();
  }

  init() {
    this.calculateHeightOverLay();
    this.addEventListener();
    this.checkTextDisclaimer();
    if (this.dom.$videos.length) {
      this.dom.$videos.each((_i, e) => {
        new BackgroundVideo(e).init();
      });
    }
    if (this.$el.hasClass('dark-overlay')) {
      $('#header').addClass('dark-overlay');
    }
  }

  checkTextDisclaimer() {
    if (this.$el.find('.declaimer-text').length > 0) {
      this.$el.addClass('has-disclaimer');
    }
  }

  addEventListener() {
    $(window).on('resize orientationchange', () => {
      this.calculateHeightOverLay();
    });

    // fix bug layout jump top when focus to element video control, VNPSPD-5077
    this.$el.find('*').each((_i, el) => {
      $(el).on('focus', () => {
        this.$el.get(0).scrollTo(0, 0);
      });
    });
  }

  calculateHeightOverLay() {
    if ($(window).innerWidth() < 991.9 && this.dom.$bottomOverlayMobile.length && this.dom.$contentDisclaimer.length) {
      const heightContentCampaign = this.dom.$wrapContentCampaign.outerHeight(true);
      const heightContentDisclaimer = this.dom.$contentDisclaimer.outerHeight(true);
      const heightOverLayText = heightContentCampaign + heightContentDisclaimer;

      this.dom.$overlayTextCampaign.css('height', heightOverLayText);
    }
  }
}